import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
interface HeaderProps {
  onRequestQuote: () => void;
}
export function Header({
  onRequestQuote
}: HeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const {
    t,
    lang,
    setLang
  } = useTranslation();
  const navigation = [{
    name: t.nav.home,
    href: '/'
  }, {
    name: t.nav.products,
    href: '/products'
  }, {
    name: t.nav.applications,
    href: '/applications'
  }, {
    name: t.nav.servis,
    href: '/servis'
  }, {
    name: t.nav.gallery,
    href: '/gallery'
  }, {
    name: t.nav.faq,
    href: '/faq'
  }, {
    name: t.nav.about,
    href: '/about'
  }, {
    name: t.nav.contact,
    href: '/contact'
  }];
  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };
  return <header className="sticky top-0 z-40 bg-dark-bg border-b-2 border-dark-border" data-id="element-396">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Glavna navigacija" data-id="element-397">
        <div className="flex items-center justify-between h-20" data-id="element-398">
          {/* Logo */}
          <Link to="/" className="flex items-center focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial" data-id="element-399">
            <img src="https://cdn.magicpatterns.com/uploads/mrmC3EPvZ6yt8zBvajm1cp/LOGO_FINAL.jpg" alt="D-TECH Solutions" className="h-12 sm:h-14 w-auto rounded" data-id="element-400" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-5 lg:space-x-6" data-id="element-401">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`text-sm font-semibold whitespace-nowrap transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial px-1 py-1 ${isActive(item.href) ? 'text-brand-yellow' : 'text-gray-300 hover:text-white'}`} data-id="element-402">
                {item.name}
              </Link>)}

            {/* Language switcher */}
            <div className="flex items-center border border-dark-border rounded-industrial overflow-hidden text-xs font-bold" data-id="element-403">
              <button onClick={() => setLang('sr')} className={`px-3 py-2 transition-colors ${lang === 'sr' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400 hover:text-white'}`} data-id="element-404">
                SR
              </button>
              <button onClick={() => setLang('en')} className={`px-3 py-2 transition-colors ${lang === 'en' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400 hover:text-white'}`} data-id="element-405">
                EN
              </button>
              <button onClick={() => setLang('ru')} className={`px-3 py-2 transition-colors ${lang === 'ru' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400 hover:text-white'}`} data-id="element-406">
                RU
              </button>
            </div>

            <Button variant="primary" size="sm" onClick={onRequestQuote} data-id="element-407">
              {t.nav.requestQuote}
            </Button>
          </div>

          {/* Mobile: lang switcher + hamburger */}
          <div className="md:hidden flex items-center gap-3" data-id="element-408">
            {/* Mobile lang switcher */}
            <div className="flex items-center border border-dark-border rounded-industrial overflow-hidden text-xs font-bold" data-id="element-409">
              <button onClick={() => setLang('sr')} className={`px-2 py-1.5 transition-colors ${lang === 'sr' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400'}`} data-id="element-410">
                SR
              </button>
              <button onClick={() => setLang('en')} className={`px-2 py-1.5 transition-colors ${lang === 'en' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400'}`} data-id="element-411">
                EN
              </button>
              <button onClick={() => setLang('ru')} className={`px-2 py-1.5 transition-colors ${lang === 'ru' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400'}`} data-id="element-412">
                RU
              </button>
            </div>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 text-white hover:text-brand-yellow transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial" aria-label="Otvori meni" aria-expanded={mobileMenuOpen} data-id="element-413">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-414" /> : <MenuIcon className="w-6 h-6" data-id="element-415" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="md:hidden py-4 border-t-2 border-dark-border" data-id="element-416">
            <div className="flex flex-col space-y-4" data-id="element-417">
              {navigation.map(item => <Link key={item.name} to={item.href} onClick={() => setMobileMenuOpen(false)} className={`text-base font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial px-2 py-2 ${isActive(item.href) ? 'text-brand-yellow' : 'text-gray-300 hover:text-white'}`} data-id="element-418">
                  {item.name}
                </Link>)}
              <Button variant="primary" size="md" onClick={() => {
            setMobileMenuOpen(false);
            onRequestQuote();
          }} className="w-full" data-id="element-419">
                {t.nav.requestQuote}
              </Button>
            </div>
          </div>}
      </nav>
    </header>;
}